<!-- Navigation -->
<navigation-bar></navigation-bar>

<!-- Content -->
<router-outlet></router-outlet>
